module.exports = __webpack_public_path__ + "assets/img/hotel-img.68c9c2e6.png";